import * as types from '../../constants/actionTypes';
import has from 'lodash/has';
import { authFetch } from '../../api';

const request = () => ({
	type: types.ADMIN_NOTIFICATION_CREATE_REQUEST,
});

const success = (notification, message = '') => ({
	type: types.ADMIN_NOTIFICATION_CREATE_SUCCESS,
	payload: {
		notification,
		message,
	},
});

const failure = (message = 'Something went wrong.') => ({
	type: types.ADMIN_NOTIFICATION_CREATE_FAILURE,
	payload: {
		message,
	},
});

export default function create(history) {
	return (dispatch, getState) => {
		const state = getState();
		const { form, auth } = state;
		const { token } = auth;

		const { message, type, from, to } = form.adminNotificationAddForm.values;

		const notification = {
			message,
			type,
			from,
			to,
		};

		dispatch(request());

		return authFetch(
			'admin-notifications',
			{
				method: 'post',
				body: JSON.stringify(notification),
			},
			token,
			dispatch,
		)
			.then(res => res.json())
			.then(res => {
				if (!has(res, 'admin_notification'))
					return has(res, 'error')
						? dispatch(failure(res.error))
						: dispatch(failure('Something went wrong.'));

				const { admin_notification, message } = res;

				dispatch(success(admin_notification, message));

				return history.push(
					`/admin-notifications/edit/${admin_notification.id}`,
				);
			})
			.catch(error => dispatch(failure(error.message || error)));
	};
}



// WEBPACK FOOTER //
// ./src/actions/adminNotifications/createAdminNotification.js